import showAlert from './alert'
import api from './api'
import EndPoint from './endpoints'
import constants from './constants'

export const Utils = {
  api,
  EndPoint,
  showAlert,
  constants,
}

export default Utils;
